import MobileTab from './MobileTab';
import MobileTabSessionDropdown from './MobileTabSessionDropdown';
const components = {
  MobileTab,
  MobileTabSessionDropdown
};
export default components;
flarum.reg.add('acpl-mobile-tab', 'forum/components', components);